export default __webpack_public_path__ + "static/media/b4.5fa278d2.jpeg";